import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 7vh;
  justify-content: space-between;
  background-color: var(--dark-blue);
  padding: 0 1%;

  
  @media (max-width: 768px) {
   font-size: 1.5em;
   line-height: 100%;
   position: sticky;
   z-index: 9999;
   top: 0;
   padding: 0 3%;
  }


  .icon {
    cursor: pointer;
    display: flex;
    height: auto;
    width: auto;
  }

   .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--white);

    .title {
      margin: 0 auto;
      width: 100%;
      text-align: center;

      span {
        margin: 0 auto;
        font-size: 18px;
        font-weight: 300;
        line-height: 28px;
        font-family: roboto, sans-serif;
      }
    }

    img {
      width: 24px;
      margin: 0;
      transition: transform 0.1s ease;

      &:active {
        transform: scale(0.9);
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .backIcon {
    margin-left: 20px;
  }

  .auxiliarIcons {
    display: flex;
    position: static;
    right: 0;
    align-items: center;
    padding-right: 20px;

    div {
      padding: 10px;
      border: 1px solid #fff;
      background-color: var(--blue);
      margin-left: 5px;
    }
  }

  .accessibilityButton{
    width: 2rem;
    height: 1.5rem;
    cursor: pointer;
  }
  .menuButtom {
    width: 1.4rem;
    height: 1.1rem;
    cursor: pointer;
  }

  .menuHamburguerWrapper {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .menuHamburguer {
    width: 2rem;
    height: 1.5rem;
  }

  .menu {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background-color: var(--dark-blue);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    padding: 8px 0;
    min-width: 180px;
    z-index: 20;
  }

  .menu-close {
    display: flex;
    justify-content: flex-end;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 1em;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    padding-right: 1rem;
  }

  .menu-item {
    display: flex;
    align-items: center;
    color: #fff;
    padding: 12px 16px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.2s;
    gap: 1rem;

    img {
      width: 2rem;
      height: 1.5rem;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  `;


export const LisaLogo = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  position: relative;
  cursor: pointer;

  .logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #Lisa {
    color: #fff;
    font-size: 20px;
    margin: 8px;
  }

  img {
    height: 30px;
  }

`;

export const CloseAiButton = styled.button`
  color: var(--white);
  background: none;
  border:none;
  font-size: 1.5rem;
`;


